var map = {
	"./google-laurel-da-DK.svg": 75786,
	"./google-laurel-de-DE.svg": 96408,
	"./google-laurel-en-GB.svg": 30154,
	"./google-laurel-en-US.svg": 5553,
	"./google-laurel-es-ES.svg": 84498,
	"./google-laurel-es-MX.svg": 12049,
	"./google-laurel-fr-FR.svg": 96626,
	"./google-laurel-it-IT.svg": 82032,
	"./google-laurel-nb-NO.svg": 77375,
	"./google-laurel-nl-NL.svg": 94094,
	"./google-laurel-pl-PL.svg": 98662,
	"./google-laurel-pt-BR.svg": 14602,
	"./google-laurel-pt-PT.svg": 1766,
	"./google-laurel-sv-SE.svg": 30243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;